import { CHAT_ROUTE, SERVER_URL } from "@/constants"

export const customFetch: (url: string, init?: RequestInit, retryCount?: number) => Promise<Response> = async (urlParam, init, retryCount = 0) => {
  const url = `${SERVER_URL}/${CHAT_ROUTE}${urlParam}`
  const modifiedInit = { ...init }
  modifiedInit.headers = {
    ...modifiedInit.headers,
  }

  const response = await fetch(url, {
    method: "GET",
    ...modifiedInit,
  })

  if (response.ok) return response

  while (retryCount) {
    const retryResponse = await fetch(url, {
      method: "GET",
      ...modifiedInit,
    })
    if (retryResponse.ok) return retryResponse
    --retryCount
  }

  throw new Error("Ошибка")
}
